export default __webpack_public_path__ + "static/media/Ape.ffda4730.webm";